"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * To be implemented
 * @visibleName WFS Search By CQL Filter Button 
 */
var WfsSearchByCQLFilterButton = function WfsSearchByCQLFilterButton(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};

var _default = WfsSearchByCQLFilterButton;
exports.default = _default;